import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { AuthService } from '@services/auth/auth.service';
import { MessageAlertService } from '@services/notifications/message-alert.service';
import { AuthFormComponent } from '@shared/components/auth-form/auth-form.component';

@Component({
	selector: 'app-reset-password-confirm',
	imports: [AuthFormComponent],
	templateUrl: './reset-password-confirm.component.html',
	styleUrl: './reset-password-confirm.component.scss',
})
export class ResetPasswordConfirmComponent implements OnInit {
	success = false;
	loading = false;
	accessToken: string | null = null;

	constructor(
		private messageAlertService: MessageAlertService,
		private route: ActivatedRoute,
		private router: Router,
		private authService: AuthService,
		private translocoService: TranslocoService,
	) {}

	ngOnInit(): void {
		// Get access token from URL fragment (Supabase sends it this way)
		this.route.fragment.subscribe((fragment) => {
			if (fragment) {
				const params = new URLSearchParams(fragment);
				this.accessToken = params.get('access_token');

				if (!this.accessToken) {
					this.messageAlertService.showMessage(
						'error',
						this.translocoService.translate('common.labels.error'),
						this.translocoService.translate('auth.resetPasswordConfirm.messages.invalidLink'),
					);
					setTimeout(() => {
						this.router.navigate(['/reset-password']);
					}, 3000);
				}
			}
		});
	}

	onSubmit(formData: { newPassword?: string; confirmPassword?: string }): void {
		if (!this.accessToken) {
			this.messageAlertService.showMessage(
				'error',
				this.translocoService.translate('common.labels.error'),
				this.translocoService.translate('auth.resetPasswordConfirm.messages.invalidLink'),
			);
			return;
		}

		this.loading = true;
		const { newPassword } = formData;

		if (!newPassword) {
			this.messageAlertService.showMessage(
				'error',
				this.translocoService.translate('common.labels.error'),
				this.translocoService.translate('auth.resetPasswordConfirm.messages.passwordRequired'),
			);
			this.loading = false;
			return;
		}

		this.authService.updatePasswordWithToken(this.accessToken, newPassword).subscribe({
			next: () => {
				this.messageAlertService.showMessage(
					'success',
					this.translocoService.translate('common.labels.success'),
					this.translocoService.translate('auth.resetPasswordConfirm.messages.passwordUpdated'),
				);
				this.success = true;
				this.loading = false;
			},
			error: () => {
				this.loading = false;
				// Error is already handled by the service
			},
		});
	}
}
